import { Typography, IconButton } from '@mui/material';
import { Skeleton } from '@mui/material';
import { styled } from '@mui/system';

interface RootDivProps {
  missingInfo: boolean;
}

const RootDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'missinInfo',
})<RootDivProps>(({ missingInfo }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
  ...(missingInfo && {
    border: '1px solid #FF0000',
  }),
}));

const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#414046',
  marginBottom: '12px',
  textAlign: 'left',
  marginLeft: '12px',
  marginTop: '12px',
});

const DivisionLine = styled('div')({
  height: '1px',
  backgroundColor: '#EAEAEA',
});

const AddressDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '14px 25px',
  borderBottom: '1px solid #EAEAEA',
  position: 'relative',
  cursor: 'pointer',
  ':nth-last-child': {
    borderBottom: 'none !important',
  },
});

const AddressInput = styled('input')({
  cursor: 'pointer',
  marginRight: '25px',
  WebkitAppearance: 'none',
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  outline: 'none',
  border: '2px solid #0277BD',
  minWidth: '20px',
  ':before': {
    content: '""',
    display: 'block',
    width: '60%',
    height: '60%',
    margin: '20% auto',
    borderRadius: '50%',
  },
  ':checked:before': {
    backgroundColor: '#0277BD',
  },
});

const AddressTypographyDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const AddressTypographyTitle = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  marginBottom: '6px',
  color: '#414046',
});

const AddressTypographySubTitle = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  margin: 0,
  color: '#919191',
});

const AddAddressDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '14px 22px',
  cursor: 'pointer',
});

const AddAddressIconButton = styled(IconButton)({
  padding: '0',
  marginRight: '17px',
  color: '#0A7ABE',
});

const AddAddressTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  color: '#0A7ABE',
  cursor: 'pointer',
});

const InfoDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '10px 10px 10px 22px',
  backgroundColor: '#E6F3FA',
  marginTop: '12px',
});

const InfoIconButton = styled(IconButton)({
  padding: '0',
  marginRight: '17px',
  color: '#414046',
});

const InfoTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '15.6px',
  letterSpacing: '0.15px',
  color: '#414046',
});

const SkeletonInput = styled(Skeleton)({
  marginRight: '25px',
});

const SkeletonTitle = styled(Skeleton)({
  marginBottom: '6px',
});

const SkeletonSubTitle = styled(Skeleton)({});

export {
  RootDiv,
  TitleTypography,
  DivisionLine,
  AddressDiv,
  AddressInput,
  AddressTypographyDiv,
  AddressTypographyTitle,
  AddressTypographySubTitle,
  AddAddressDiv,
  AddAddressIconButton,
  AddAddressTypography,
  InfoDiv,
  InfoIconButton,
  InfoTypography,
  SkeletonInput,
  SkeletonTitle,
  SkeletonSubTitle,
};
